import * as React from 'react';

import upperFirst from 'lodash/upperFirst';

import { STATUS } from 'pages/views/devices/socketClient/types';
import { PRINTER_STATUSES } from 'pages/views/devices/types';

import { StyledPillBadge } from './StatusLabel.style';

interface Props {
  status: PRINTER_STATUSES | STATUS;
  size: 'small' | 'medium';
  className?: string;
}

const StatusLabel: React.FunctionComponent<Props> = ({ status, size, className }) => {
  const connectionStatus = status.toUpperCase() || PRINTER_STATUSES.DISCONNECTED;
  let labelProps;

  switch (connectionStatus) {
    case 'CONNECTED': {
      labelProps = {
        backgroundColor: 'green-200',
        borderColor: 'green-400',
      };
      break;
    }
    case PRINTER_STATUSES.LOW_PAPER:
    case PRINTER_STATUSES.PAUSED:
    case PRINTER_STATUSES.COVER_OPEN:
    case PRINTER_STATUSES.NOT_RESPONDING: {
      labelProps = {
        backgroundColor: 'orange-100',
        borderColor: 'orange-300',
      };
      break;
    }
    case PRINTER_STATUSES.DISCONNECTED:
    case PRINTER_STATUSES.NO_PAPER:
    case PRINTER_STATUSES.PAPER_JAM:
    case PRINTER_STATUSES.OVERHEATED:
    case PRINTER_STATUSES.ERROR: {
      labelProps = {
        backgroundColor: 'maple-200',
        borderColor: 'maple-300',
      };
      break;
    }
    case PRINTER_STATUSES.READY:
    default: {
      labelProps = {
        backgroundColor: 'gray-100',
        borderColor: 'gray-300',
      };
    }
  }

  return connectionStatus !== PRINTER_STATUSES.NOT_AVAILABLE ? (
    <StyledPillBadge className={className} size={size} {...labelProps}>
      {upperFirst(connectionStatus.replace('_', ' ').toLowerCase())}
    </StyledPillBadge>
  ) : null;
};

export { StatusLabel };
